import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { errors, paxRoute, sessionRequired, staffAuth } from "../../common";
import { ClosePlayerRequest, ClosePlayerResponse, UserParams } from "./schemas";

export const closePlayer = oc
  .meta(
    paxRoute({ auth: staffAuth("credits.manage"), minimumTier: "suspicious", cost: "write" }),
    openapi({
      method: "POST",
      path: "/api/accounting/v1alpha1/players/{userId}/close",
      operationId: "accounting.players.close.create",
      summary: "Close a player.",
      description:
        "Cancels the player's Stripe subscriptions and open checkouts, then closes their ledger record and zeros each named balance. Open holds keep what they reserve.",
      inputStructure: "detailed",
      successDescription: "The closure that was recorded.",
    }),
  )
  .errors({
    ...errors.badRequest,
    ...sessionRequired,
    ...errors.forbidden,
    NOT_FOUND: { message: "No player has that id." },
    CONFLICT: {
      message:
        "The player is already closed, the closure id was already recorded for a different change, or the input is invalid.",
    },
    BAD_GATEWAY: {
      message:
        "Stripe could not end this player's payments, so the player was not closed. Try again in a moment.",
    },
  })
  .input(z.object({ params: UserParams, body: ClosePlayerRequest }))
  .output(ClosePlayerResponse);
